import Colors from "@constants/Colors";
import { Box } from "@mui/material";
import styled from "styled-components";

export const CustomCardWrapper = styled.div`
  top: 164px;
  padding: 16px 16px 0px 16px !important;
`;

export const StyledRootBox = styled(Box)`
  background-color: ${Colors.neutralwhite_50};
`;
